import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import StrangerAccessPermissions, { StrangerPermissions } from 'src/app/core/models/stranger-permissions';
import { RegistrationRequestViewModalComponent } from '../registration-request-view-modal/registration-request-view-modal.component';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { CountriesResponse } from 'src/app/core/models/country';
import AccountUserInfo from 'src/app/core/models/AccountUserInfo';
import { getRequestStatusIconName, getRequestStatusName, RegistrationRequestStatus } from 'src/app/core/models/registration-request-status';
import { MatDialog } from '@angular/material/dialog';
import { JoinOrganizationModalComponent, JoinOrganizationModalData } from '../join-organization-modal/join-organization-modal.component';
@Component({
  selector: 'stranger-permissions',
  templateUrl: './stranger-permissions.component.html',
  styleUrls: ['./stranger-permissions.component.scss'],
})
export class StrangerPermissionsComponent {
  @Input() accessPermissions: StrangerAccessPermissions = {} as StrangerAccessPermissions;
  @Input() userInfo: AccountUserInfo | null = null;
  @Input() countriesAll: CountriesResponse[] = [];
  @Input() language: string | null = null;

  @Output() requestAccessRightsClicked: EventEmitter<number> = new EventEmitter<number>();
  @Output() registrationRequestChange: EventEmitter<void> = new EventEmitter<void>();
  displayedColumns: string[] = ['clientName', 'roleName', 'registrationRequest', 'status', 'actions'];

  constructor(
    private translocoService: TranslocoService,
    private legacyDialog: MatLegacyDialog,
    public dialog: MatDialog
  ) {}

  getActiveLang() {
    return this.translocoService.getActiveLang();
  }

  getRoleName(elem: StrangerPermissions) {
    return this.getActiveLang() == 'ru' ? elem.roleName : elem.roleNameEn;
  }

  getClientName(elem: StrangerPermissions) {
    return this.getActiveLang() == 'ru' ? elem.clientName : elem.clientNameEn;
  }

  getStatusName(elem: StrangerPermissions) {
    return elem?.status ? getRequestStatusName(elem?.status ?? '', this.translocoService) : '';
  }

  getStatusIcon(elem: StrangerPermissions) {
    return elem?.status ? getRequestStatusIconName(elem?.status ?? '') : '';
  }

  getRequestData(el: StrangerPermissions) {
    const dialogRef = this.legacyDialog.open(RegistrationRequestViewModalComponent, {
      data: { request: el, countriesAll: this.countriesAll },
      panelClass: 'l',
      maxHeight: '99vh',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.registrationRequestChange.emit();
      }
    });
  }

  /**
   * Принудительно отправить в очередь на регистрацию нового иностранца в конкретную ИС
   */
  requestAccessRights(client: StrangerPermissions) {
    const dialogData: JoinOrganizationModalData = {
      strangerInfo: client ?? {},
      phoneCountries: this.countriesAll
    }
    const dialogRef = this.dialog.open(JoinOrganizationModalComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.requestAccessRightsClicked.emit();
      }
    });
  }

  canEditRequest(client: StrangerPermissions): boolean {
    return client.status === RegistrationRequestStatus.DeclinedByChief || client.status === RegistrationRequestStatus.DeclinedByController;
  }
}
